import {Component, OnDestroy, OnInit} from '@angular/core';
import {CarMarca} from "../../../modelo/soporte/car-marca";
import {SubscriptionLike} from "rxjs";
import {CarMarcaService} from "../../../servicios/soporte/car-marca.service";

@Component({
  selector: 'app-marcas',
  templateUrl: './marcas.component.html',
  styleUrls: ['./marcas.component.css']
})
export class MarcasComponent implements OnInit, OnDestroy {
  private subs:SubscriptionLike[];

  public marcas:CarMarca[];

  constructor(private carMarcaSV:CarMarcaService) {
    this.subs=[];
    this.marcas=[];
  }

  ngOnInit(): void {
    this.subs.push(
      this.carMarcaSV.listarCarMarca().subscribe(res=>{
        this.marcas=res.data;
      })
    )
  }

  ngOnDestroy(): void {
    this.subs.forEach(s=>s.unsubscribe());
  }

}
